// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ai-chat-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(15, 23, 42, 0.18);
  opacity: 0;
  pointer-events: none;
  transition: 0.25s ease;
  z-index: 80;
}

.ai-chat-backdrop.show {
  opacity: 1;
  pointer-events: auto;
}

.ai-chat-drawer {
  position: fixed;
  top: 110px;
  right: 24px;
  width: 440px;
  max-width: calc(100vw - 32px);
  height: calc(100vh - 135px);
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid rgba(226, 232, 240, 0.95);
  border-radius: 28px;
  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.24);
  transform: translateX(115%);
  transition: 0.28s ease;
  z-index: 90;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  backdrop-filter: blur(18px);
}

.ai-chat-drawer.open {
  transform: translateX(0);
}

.ai-chat-header {
  padding: 20px;
  background: linear-gradient(135deg, #111236, #4f46e5 55%, #7c3aed);
  color: #f8fafc;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.ai-chat-header h3 {
  margin: 0;
  font-size: 21px;
  font-weight: 800;
  color: #ffffff;
}

.ai-chat-header span {
  display: block;
  margin-top: 6px;
  font-size: 12px;
  color: #dbeafe;
  opacity: 0.95;
}

.ai-chat-label {
  margin: 0 0 6px;
  font-size: 11px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: #c7d2fe;
  opacity: 1;
}

.ai-chat-close {
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.16);
  color: #ffffff;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.ai-chat-close:hover {
  background: rgba(255, 255, 255, 0.24);
}

.ai-chat-context {
  padding: 14px 18px;
  display: flex;
  justify-content: space-between;
  gap: 12px;
  background: #f7f8ff;
  border-bottom: 1px solid #e6e9f5;
}

.ai-chat-context strong {
  color: #111827;
  font-size: 13px;
}

.ai-chat-context small {
  color: #64748b;
  text-align: right;
  line-height: 1.35;
}

.ai-chat-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 18px;
  background:
    radial-gradient(circle at top left, rgba(109, 93, 252, 0.08), transparent 30%),
    #fbfcff;
}

.ai-chat-message {
  display: flex;
  margin-bottom: 14px;
}

.ai-chat-message.user {
  justify-content: flex-end;
}

.ai-chat-message.assistant {
  justify-content: flex-start;
}

.ai-chat-bubble {
  max-width: 86%;
  padding: 13px 15px;
  border-radius: 18px;
  font-size: 14px;
  line-height: 1.55;
  white-space: pre-wrap;
  word-break: break-word;
}

.ai-chat-message.assistant .ai-chat-bubble {
  background: #ffffff;
  color: #0f172a;
  border: 1px solid #e5e7eb;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);
}

.ai-chat-message.user .ai-chat-bubble {
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  color: #ffffff;
  box-shadow: 0 12px 28px rgba(109, 93, 252, 0.28);
}

.ai-chat-bubble-image {
  display: block;
  width: 100%;
  max-width: 260px;
  max-height: 190px;
  object-fit: cover;
  border-radius: 14px;
  margin-bottom: 10px;
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.ai-chat-message.assistant .ai-chat-bubble-image {
  border-color: #e2e8f0;
}

.ai-camera-box {
  padding: 12px 14px;
  background: #f8fafc;
  border-top: 1px solid #e5e7eb;
}

.ai-camera-video {
  width: 100%;
  max-height: 220px;
  object-fit: cover;
  border-radius: 16px;
  border: 1px solid #dbe3ef;
  background: #020617;
}

.ai-camera-actions {
  display: flex;
  gap: 10px;
  margin-top: 10px;
}

.ai-camera-actions button {
  flex: 1 1;
  border: 0;
  border-radius: 14px;
  padding: 10px 12px;
  font-weight: 800;
  cursor: pointer;
}

.ai-camera-actions button:first-child {
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  color: #ffffff;
}

.ai-camera-actions button:last-child {
  background: #e2e8f0;
  color: #1e293b;
}

.ai-image-preview {
  padding: 12px 14px;
  border-top: 1px solid #e5e7eb;
  background: #ffffff;
}

.ai-preview-img {
  width: 100%;
  max-height: 180px;
  object-fit: cover;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  margin-bottom: 8px;
}

.ai-image-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  font-size: 12px;
  color: #475569;
}

.ai-image-actions span {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.ai-image-actions button {
  border: 0;
  background: #fee2e2;
  color: #b91c1c;
  padding: 6px 10px;
  border-radius: 10px;
  cursor: pointer;
  font-weight: 800;
}

.ai-image-actions button:hover {
  background: #fecaca;
}

.ai-chat-suggestions {
  padding: 12px 14px;
  display: flex;
  gap: 8px;
  overflow-x: auto;
  border-top: 1px solid #eef2f7;
  background: #ffffff;
}

.ai-chat-suggestions button {
  border: 1px solid #dbe3ef;
  background: #f8fafc;
  color: #1e293b;
  border-radius: 999px;
  padding: 9px 12px;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
  cursor: pointer;
}

.ai-chat-suggestions button:hover {
  background: #eef2ff;
  border-color: #c7d2fe;
  color: #3730a3;
}

.ai-chat-input-wrap {
  padding: 14px;
  display: flex;
  gap: 10px;
  align-items: flex-end;
  background: #ffffff;
  border-top: 1px solid #e5e7eb;
}

.ai-chat-input-wrap textarea {
  flex: 1 1;
  resize: none;
  border: 1px solid #dbe3ef;
  border-radius: 18px;
  padding: 12px 14px;
  font-size: 14px;
  outline: none;
  min-height: 46px;
  max-height: 120px;
  color: #0f172a;
  background: #ffffff;
}

.ai-chat-input-wrap textarea::placeholder {
  color: #94a3b8;
}

.ai-chat-input-wrap textarea:focus {
  border-color: #6d5dfc;
  box-shadow: 0 0 0 4px rgba(109, 93, 252, 0.12);
}

.ai-chat-input-wrap button {
  border: 0;
  border-radius: 16px;
  padding: 13px 18px;
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  color: #ffffff;
  font-weight: 800;
  cursor: pointer;
  box-shadow: 0 12px 28px rgba(109, 93, 252, 0.28);
}

.ai-chat-input-wrap button:hover:not(:disabled) {
  transform: translateY(-1px);
}

.ai-chat-input-wrap button:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.ai-chat-tools {
  padding: 0 14px 14px;
  display: flex;
  gap: 8px;
  background: #ffffff;
}

.ai-chat-tools button {
  width: 38px;
  height: 34px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #f8fafc;
  color: #0f172a;
  cursor: pointer;
  font-weight: 800;
}

.ai-chat-tools button:hover {
  background: #eef2ff;
  border-color: #c7d2fe;
}

.ai-chat-tools button.recording {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
  width: auto;
  padding: 0 10px;
}

@media (max-width: 1024px) {
  .ai-chat-drawer {
    top: 96px;
    right: 16px;
    height: calc(100vh - 116px);
  }
}

@media (max-width: 768px) {
  .ai-chat-drawer {
    top: auto;
    right: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    height: 84vh;
    border-radius: 26px 26px 0 0;
    transform: translateY(110%);
  }

  .ai-chat-drawer.open {
    transform: translateY(0);
  }

  .ai-chat-context {
    flex-direction: column;
  }

  .ai-chat-context small {
    text-align: left;
  }

  .ai-chat-bubble {
    max-width: 92%;
    font-size: 13.5px;
  }

  .ai-camera-video {
    max-height: 180px;
  }

  .ai-preview-img {
    max-height: 150px;
  }
}

.ai-image-progress {
  width: 100%;
  height: 7px;
  margin-top: 12px;
  background: #e5e7eb;
  border-radius: 999px;
  overflow: hidden;
}

.ai-image-progress div {
  height: 100%;
  background: linear-gradient(135deg, #4f46e5, #7c3aed);
  border-radius: 999px;
  transition: width 0.35s ease;
}`, "",{"version":3,"sources":["webpack://./src/components/SessionAIChatDrawer.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,kCAAkC;EAClC,UAAU;EACV,oBAAoB;EACpB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,UAAU;EACV,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,2BAA2B;EAC3B,qCAAqC;EACrC,2CAA2C;EAC3C,mBAAmB;EACnB,8CAA8C;EAC9C,2BAA2B;EAC3B,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;EACd,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb;;WAES;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qDAAqD;EACrD,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,qDAAqD;EACrD,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gDAAgD;AAClD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,eAAe;AACjB;;AAEA;EACE;IACE,SAAS;IACT,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,SAAS;IACT,QAAQ;IACR,SAAS;IACT,WAAW;IACX,eAAe;IACf,YAAY;IACZ,4BAA4B;IAC5B,2BAA2B;EAC7B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,qDAAqD;EACrD,oBAAoB;EACpB,4BAA4B;AAC9B","sourcesContent":[".ai-chat-backdrop {\n  position: fixed;\n  inset: 0;\n  background: rgba(15, 23, 42, 0.18);\n  opacity: 0;\n  pointer-events: none;\n  transition: 0.25s ease;\n  z-index: 80;\n}\n\n.ai-chat-backdrop.show {\n  opacity: 1;\n  pointer-events: auto;\n}\n\n.ai-chat-drawer {\n  position: fixed;\n  top: 110px;\n  right: 24px;\n  width: 440px;\n  max-width: calc(100vw - 32px);\n  height: calc(100vh - 135px);\n  background: rgba(255, 255, 255, 0.98);\n  border: 1px solid rgba(226, 232, 240, 0.95);\n  border-radius: 28px;\n  box-shadow: 0 30px 80px rgba(15, 23, 42, 0.24);\n  transform: translateX(115%);\n  transition: 0.28s ease;\n  z-index: 90;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  backdrop-filter: blur(18px);\n}\n\n.ai-chat-drawer.open {\n  transform: translateX(0);\n}\n\n.ai-chat-header {\n  padding: 20px;\n  background: linear-gradient(135deg, #111236, #4f46e5 55%, #7c3aed);\n  color: #f8fafc;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n}\n\n.ai-chat-header h3 {\n  margin: 0;\n  font-size: 21px;\n  font-weight: 800;\n  color: #ffffff;\n}\n\n.ai-chat-header span {\n  display: block;\n  margin-top: 6px;\n  font-size: 12px;\n  color: #dbeafe;\n  opacity: 0.95;\n}\n\n.ai-chat-label {\n  margin: 0 0 6px;\n  font-size: 11px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: #c7d2fe;\n  opacity: 1;\n}\n\n.ai-chat-close {\n  width: 36px;\n  height: 36px;\n  border: 0;\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.16);\n  color: #ffffff;\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.ai-chat-close:hover {\n  background: rgba(255, 255, 255, 0.24);\n}\n\n.ai-chat-context {\n  padding: 14px 18px;\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  background: #f7f8ff;\n  border-bottom: 1px solid #e6e9f5;\n}\n\n.ai-chat-context strong {\n  color: #111827;\n  font-size: 13px;\n}\n\n.ai-chat-context small {\n  color: #64748b;\n  text-align: right;\n  line-height: 1.35;\n}\n\n.ai-chat-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 18px;\n  background:\n    radial-gradient(circle at top left, rgba(109, 93, 252, 0.08), transparent 30%),\n    #fbfcff;\n}\n\n.ai-chat-message {\n  display: flex;\n  margin-bottom: 14px;\n}\n\n.ai-chat-message.user {\n  justify-content: flex-end;\n}\n\n.ai-chat-message.assistant {\n  justify-content: flex-start;\n}\n\n.ai-chat-bubble {\n  max-width: 86%;\n  padding: 13px 15px;\n  border-radius: 18px;\n  font-size: 14px;\n  line-height: 1.55;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.ai-chat-message.assistant .ai-chat-bubble {\n  background: #ffffff;\n  color: #0f172a;\n  border: 1px solid #e5e7eb;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.06);\n}\n\n.ai-chat-message.user .ai-chat-bubble {\n  background: linear-gradient(135deg, #4f46e5, #7c3aed);\n  color: #ffffff;\n  box-shadow: 0 12px 28px rgba(109, 93, 252, 0.28);\n}\n\n.ai-chat-bubble-image {\n  display: block;\n  width: 100%;\n  max-width: 260px;\n  max-height: 190px;\n  object-fit: cover;\n  border-radius: 14px;\n  margin-bottom: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.3);\n}\n\n.ai-chat-message.assistant .ai-chat-bubble-image {\n  border-color: #e2e8f0;\n}\n\n.ai-camera-box {\n  padding: 12px 14px;\n  background: #f8fafc;\n  border-top: 1px solid #e5e7eb;\n}\n\n.ai-camera-video {\n  width: 100%;\n  max-height: 220px;\n  object-fit: cover;\n  border-radius: 16px;\n  border: 1px solid #dbe3ef;\n  background: #020617;\n}\n\n.ai-camera-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 10px;\n}\n\n.ai-camera-actions button {\n  flex: 1;\n  border: 0;\n  border-radius: 14px;\n  padding: 10px 12px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.ai-camera-actions button:first-child {\n  background: linear-gradient(135deg, #4f46e5, #7c3aed);\n  color: #ffffff;\n}\n\n.ai-camera-actions button:last-child {\n  background: #e2e8f0;\n  color: #1e293b;\n}\n\n.ai-image-preview {\n  padding: 12px 14px;\n  border-top: 1px solid #e5e7eb;\n  background: #ffffff;\n}\n\n.ai-preview-img {\n  width: 100%;\n  max-height: 180px;\n  object-fit: cover;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  margin-bottom: 8px;\n}\n\n.ai-image-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 10px;\n  font-size: 12px;\n  color: #475569;\n}\n\n.ai-image-actions span {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.ai-image-actions button {\n  border: 0;\n  background: #fee2e2;\n  color: #b91c1c;\n  padding: 6px 10px;\n  border-radius: 10px;\n  cursor: pointer;\n  font-weight: 800;\n}\n\n.ai-image-actions button:hover {\n  background: #fecaca;\n}\n\n.ai-chat-suggestions {\n  padding: 12px 14px;\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  border-top: 1px solid #eef2f7;\n  background: #ffffff;\n}\n\n.ai-chat-suggestions button {\n  border: 1px solid #dbe3ef;\n  background: #f8fafc;\n  color: #1e293b;\n  border-radius: 999px;\n  padding: 9px 12px;\n  font-size: 12px;\n  font-weight: 700;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n.ai-chat-suggestions button:hover {\n  background: #eef2ff;\n  border-color: #c7d2fe;\n  color: #3730a3;\n}\n\n.ai-chat-input-wrap {\n  padding: 14px;\n  display: flex;\n  gap: 10px;\n  align-items: flex-end;\n  background: #ffffff;\n  border-top: 1px solid #e5e7eb;\n}\n\n.ai-chat-input-wrap textarea {\n  flex: 1;\n  resize: none;\n  border: 1px solid #dbe3ef;\n  border-radius: 18px;\n  padding: 12px 14px;\n  font-size: 14px;\n  outline: none;\n  min-height: 46px;\n  max-height: 120px;\n  color: #0f172a;\n  background: #ffffff;\n}\n\n.ai-chat-input-wrap textarea::placeholder {\n  color: #94a3b8;\n}\n\n.ai-chat-input-wrap textarea:focus {\n  border-color: #6d5dfc;\n  box-shadow: 0 0 0 4px rgba(109, 93, 252, 0.12);\n}\n\n.ai-chat-input-wrap button {\n  border: 0;\n  border-radius: 16px;\n  padding: 13px 18px;\n  background: linear-gradient(135deg, #4f46e5, #7c3aed);\n  color: #ffffff;\n  font-weight: 800;\n  cursor: pointer;\n  box-shadow: 0 12px 28px rgba(109, 93, 252, 0.28);\n}\n\n.ai-chat-input-wrap button:hover:not(:disabled) {\n  transform: translateY(-1px);\n}\n\n.ai-chat-input-wrap button:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.ai-chat-tools {\n  padding: 0 14px 14px;\n  display: flex;\n  gap: 8px;\n  background: #ffffff;\n}\n\n.ai-chat-tools button {\n  width: 38px;\n  height: 34px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #f8fafc;\n  color: #0f172a;\n  cursor: pointer;\n  font-weight: 800;\n}\n\n.ai-chat-tools button:hover {\n  background: #eef2ff;\n  border-color: #c7d2fe;\n}\n\n.ai-chat-tools button.recording {\n  background: #fee2e2;\n  border-color: #fecaca;\n  color: #b91c1c;\n  width: auto;\n  padding: 0 10px;\n}\n\n@media (max-width: 1024px) {\n  .ai-chat-drawer {\n    top: 96px;\n    right: 16px;\n    height: calc(100vh - 116px);\n  }\n}\n\n@media (max-width: 768px) {\n  .ai-chat-drawer {\n    top: auto;\n    right: 0;\n    bottom: 0;\n    width: 100%;\n    max-width: 100%;\n    height: 84vh;\n    border-radius: 26px 26px 0 0;\n    transform: translateY(110%);\n  }\n\n  .ai-chat-drawer.open {\n    transform: translateY(0);\n  }\n\n  .ai-chat-context {\n    flex-direction: column;\n  }\n\n  .ai-chat-context small {\n    text-align: left;\n  }\n\n  .ai-chat-bubble {\n    max-width: 92%;\n    font-size: 13.5px;\n  }\n\n  .ai-camera-video {\n    max-height: 180px;\n  }\n\n  .ai-preview-img {\n    max-height: 150px;\n  }\n}\n\n.ai-image-progress {\n  width: 100%;\n  height: 7px;\n  margin-top: 12px;\n  background: #e5e7eb;\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.ai-image-progress div {\n  height: 100%;\n  background: linear-gradient(135deg, #4f46e5, #7c3aed);\n  border-radius: 999px;\n  transition: width 0.35s ease;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
